export default __webpack_public_path__ + "static/Fabuloso-79c24c7153a0d587dcbbedaad7244efa.png";